/*
 *   File : statistics.js
 *   Author : https://evoqins.com
 *   Description : Statistics card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo } from 'react';

//custom style
import styles from "../../Style/Component/card.module.scss";

const StatisticCard = (props) => {
    return (
        <>
            {props.type === 2 ?
                <div className={`${styles.e_list_statistics_card_wrapper} ${props.className ?? ""} transition e-bg-white e-border-radius-16 p-4 `}>
                    <p className={`mb-0  e-text-deep-onyx e-alt-font-noto-sans e-font-weight-500 e-font-14 line-height-24px`}>
                        {props.title}
                    </p>
                    {props.loader ?
                        <div class="pt-3 placeholder-glow ">
                            <p class="mb-0 h-34px placeholder col-5 e-border-radius-8 e-bg-columbia-blue"></p>
                        </div>
                        :
                        <p className={`pt-3 mb-0 e-text-raisin-black e-alt-font-noto-sans e-font-weight-600 e-font-20 line-height-24px`}>
                            {props.quantity}
                        </p>
                    }

                </div >
                :
                <>
                    {props.loader ?
                        <div class={`${styles.e_statistics_card_wrapper} ${props.className} skeleton-loader  placeholder-glow padding-22px-all w-100`} style={{ height: "150px" }}>
                            {/* <p class="mb-0 e-border-radius-8 w-100 h-100 skeleton-loader " ></p> */}
                        </div>
                        :
                        <div className={`${styles.e_statistics_card_wrapper} ${props.className} transition e-bg-white e-border-radius-8 padding-22px-all d-flex flex-column h-100`}>
                            <img src={props.icon}
                                draggable={false}
                                width={24}
                                height={24}
                                alt='icon' />
                            {/* {props.loader ?
                                <div class="pt-3 placeholder-glow ">
                                    <p class="mb-0 h-34px placeholder col-5 e-border-radius-8 e-bg-columbia-blue"></p>
                                </div>
                                : */}
                            <p className={`pt-3 mb-0 e-text-black e-alt-font-noto-sans e-font-weight-400 e-font-32 line-height-34px`}>
                                {props.quantity}
                            </p>
                            {/* } */}
                            <p className={`pt-3 mb-0  e-text-sonic-silver e-alt-font-noto-sans e-font-weight-500 e-font-16 line-height-16px w-max-`}>
                                {props.title}
                            </p>
                        </div >
                    }
                </>

            }
        </>

    )
}

export default memo(StatisticCard);